<template>
  <div class="booking-addNotes">
    <div class="booking-addNotes-form">
      <van-field
        v-model="message"
        rows="5"
        label=""
        type="textarea"
        placeholder="请输入您需要备注的内容"
      />
      <div class="booking-addNotes-form-btn">
        <el-button @click="goBack">取消</el-button>
        <el-button
          type="danger"
          @click="submit"
          :disabled="subminting"
          :loading="subminting"
        >保存</el-button>
      </div>
    </div>
    <div class="booking-division" />
    <div class="booking-addNotes-history">
      <div class="booking-addNotes-history-title">
        历史备注记录

      </div>
      <div class="booking-addNotes-history-list">

        <div
          class="booking-addNotes-history-list-item"
          v-for="(item) in messageList"
          :key="item.id"
        >
          <div class="booking-addNotes-history-list-item-title">
            {{ item.create_time }}

          </div>
          <div class="booking-addNotes-history-list-item-content">
            {{ item.notes }}
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import menzhenService from "@/apis/menZhen";
import { Toast } from "vant";
import enums from "@/views/booking/mixins/enums";

export default {
  data() {
    return {
      message: "",
      messageList: [],
      subminting: false,
    };
  },
  mixins: [enums],

  created() {
    this.getCommentList();
  },
  methods: {
    getCommentList() {
      const params = {
        apply_id: this.$route.query.id,
      };
      menzhenService.commentList(params).then((res) => {
        this.messageList = res;
        console.log(res);
      });
    },

    submit() {
      const { message, currentUserInfo } = this;
      if (!message) {
        Toast("请输入备注内容");
        return;
      }

      const params = {
        submit_id: currentUserInfo.user_id,
        submit_name: currentUserInfo.user_name,
        notes: message,
        apply_id: this.$route.query.id,
      };
      this.subminting = true;
      menzhenService
        .commentAppend(params)
        .then((res) => {
          this.subminting = false;
          Toast("保存成功");
          this.message = "";
          this.getCommentList();
          console.log(res);
        })
        .catch(() => {
          this.subminting = false;
        });
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.booking-addNotes-form {
  padding: 20px;
  .van-cell {
    border: 1px solid #ebedf0;
    border-radius: 5px;
  }
  .booking-addNotes-form-btn {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
  }
}
.booking-addNotes-history {
  padding: 10px 20px;
  .booking-addNotes-history-title {
    font-size: 18px;
    font-weight: bold;
  }
  .booking-addNotes-history-list-item {
    padding: 10px 0;
    border-bottom: 1px solid #e5e5e5;
  }
  .booking-addNotes-history-list-item-title {
    font-size: 16px;
  }
  .booking-addNotes-history-list-item-content {
    margin-top: 10px;
  }
}
</style>